// extracted by mini-css-extract-plugin
module.exports = {"teaserText":"TeaserText_teaserText__23krM"};